import { gql } from "@apollo/client";

/**
 * GraphQL documents for Settings › Ticket Management › Email Rules: rules that
 * turn new mail on a company email account into a Support Ticket of a chosen
 * type. Re-exported through `~/api`.
 */

const EmailTicketRuleData = gql`
  fragment EmailTicketRuleData on EmailTicketRule {
    _id
    emailAccount {
      _id
      emailAddress
      emailAccountStatus
      needsReconnect
    }
    supportTicketType {
      _id
      name
      icon
      color
      isInternal
    }
    createdAt
    updatedAt
  }
`;

export const LIST_OWN_OEM_EMAIL_TICKET_RULES_QUERY = gql`
  query listOwnOemEmailTicketRules {
    listOwnOemEmailTicketRules {
      ...EmailTicketRuleData
    }
  }
  ${EmailTicketRuleData}
`;

export const CREATE_OEM_EMAIL_TICKET_RULE_MUTATION = gql`
  mutation createOemEmailTicketRule($input: EmailTicketRuleInput!) {
    createOemEmailTicketRule(input: $input) {
      ...EmailTicketRuleData
    }
  }
  ${EmailTicketRuleData}
`;

export const UPDATE_OEM_EMAIL_TICKET_RULE_MUTATION = gql`
  mutation updateOemEmailTicketRule($id: ID!, $input: EmailTicketRuleInput!) {
    updateOemEmailTicketRule(id: $id, input: $input) {
      ...EmailTicketRuleData
    }
  }
  ${EmailTicketRuleData}
`;

export const DELETE_OEM_EMAIL_TICKET_RULE_MUTATION = gql`
  mutation deleteOemEmailTicketRule($id: ID!) {
    deleteOemEmailTicketRule(id: $id)
  }
`;
